import tokenStorage from '../token-storage'

const DESTRUCTIVE_HTTP_VERBS = new Set(['POST', 'PUT', 'PATCH', 'DELETE'])

export const generateDefaultHeaders = (authTokenKey) => {
  const token = tokenStorage.get()
  const headers = new Headers()
  headers.append('Authorization', token)
  headers.append('Content-Type', 'application/json')
  return headers
}

/**
 * @param httpVerb, {String} upper case string of chosen HTTP method
 * @param body, {String} serialzed body for a destructive request. Pass empty
 *   string for safe HTTP methods.
 * @param headers, {Object}, can be a Headers object
 */
export const buildConfig = (httpVerb, body, headers) => {
  const config = {
    method: httpVerb,
    headers,
  }

  if (DESTRUCTIVE_HTTP_VERBS.has(httpVerb)) { config.body = body }

  return config
}

export default (verb, body) => {
  const headers = generateDefaultHeaders('rr_token')
  return buildConfig(verb, body, headers)
}



// WEBPACK FOOTER //
// ./src/services/fetchApi/configure-request.js